module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre6",
    attrs: {
      "id": "pgepubid00011"
    }
  }, [_vm._v("The Golden Ball")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("There were two lasses, daughters of one mother, and as they came from the fair, they saw a right bonny young man stand at the house-door before them. They never saw such a bonny man before. He had gold on his cap, gold on his finger, gold on his neck, a red gold watch-chain—eh! but he had brass. He had a golden ball in each hand. He gave a ball to each lass, and she was to keep it, and if she lost it, she was to be hanged. One of the lasses, 't was the youngest, lost her ball. I'll tell thee how. She was by a park-paling, and she was tossing her ball, and it went up, and up, and up, till it went fair over the paling; and when she climbed up to look, the ball ran along the green grass, and it went right forward to the door of the house, and the ball went in and she saw it no more.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("So she was taken away to be hanged by the neck till she was dead because she'd lost her ball.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But she had a sweetheart, and he said he would go and get the ball. So he went to the park-gate, but 't was shut; so he climbed the hedge, and when he got to the top of the hedge, an old woman rose up out of the dyke before him, and said, if he wanted to get the ball, he must sleep three nights in the house. He said he would.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Then he went into the house, and looked for the ball, but could not find it. Night came on and he heard bogles move in the courtyard; so he looked out o' the window, and the yard was full of them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Presently he heard steps coming upstairs. He hid behind the door, and was as still as a mouse. Then in came a big giant five times as tall as he, and the giant looked round but did not see the lad, so he went to the window and bowed to look out; and as he bowed on his elbows to see the bogles in the yard, the lad stepped behind him, and with one blow of his sword he cut him in twain, so that the top part of him fell in the yard, and the bottom part stood looking out of the window.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("There was a great cry from the bogles when they saw half the giant come tumbling down to them, and they called out, \"There comes half our master, give us the other half.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("So the lad said, \"It's no use of thee, thou pair of legs, standing alone at the window, as thou hast no eye to see with, so go join thy brother;\" and he cast the lower part of the giant after the top part. Now when the bogles had gotten all the giant they were quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Next night the lad was at the house again, and now a second giant came in at the door, and as he came in the lad cut him in twain, but the legs walked on to the chimney and went up them. \"Go, get thee after thy legs,\" said the lad to the head, and he cast the head up the chimney too.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("The third night the lad got into bed, and he heard the bogles striving under the bed, and they had the ball there, and they were casting it to and fro.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Now one of them has his leg thrust out from under the bed, so the lad brings his sword down and cuts it off. Then another thrusts his arm out at other side of the bed, and the lad cuts that off. So at last he had maimed them all, and they all went crying and wailing off, and forgot the ball, but he took it from under the bed, and went to seek his true-love.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Now the lass was taken to York to be hanged; she was brought out on the scaffold, and the hangman said, \"Now, lass, thou must hang by the neck till thou be'st dead.\" But she cried out:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("\"Stop, stop, I think I see my mother coming!")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("O mother, hast brought my golden ball")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("And come to set me free?\"")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("\"I've neither brought thy golden ball")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("Nor come to set thee free,")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("But I have come to see thee hung")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("Upon this gallows-tree.\"")]), _c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Then the hangman said, \"Now, lass, say thy prayers for thou must die.\" But she said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("\"Stop, stop, I think I see my father coming!")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("O father, hast brought my golden ball")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("And come to set me free?\"")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("\"I've neither brought thy golden ball")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("Nor come to set thee free,")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("But I have come to see thee hung")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("Upon this gallows-tree.\"")]), _c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Then the hangman said, \"Hast thee done thy prayers? Now, lass, put thy head into the noose.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But she answered, \"Stop, stop, I think I see my brother coming!\" And again she sang, and then she thought she saw her sister coming, then her uncle, then her aunt, then her cousin; but after this the hangman said, \"I will stop no longer, thou 'rt making game of me. Thou must be hung at once.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But now she saw her sweetheart coming through the crowd, and he held over his head in the air her own golden ball; so she said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("\"Stop, stop, I see my sweetheart coming!")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("Sweetheart, hast brought my golden ball")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("And come to set me free?\"")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("\"Aye, I have brought thy golden ball")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("And come to set thee free,")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c5"
  }, [_vm._v("I have not come to see thee hung")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('span', {
    staticClass: "c6"
  }, [_vm._v("Upon this gallows-tree.\"")]), _c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("And he took her home, and they lived happy ever after.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    attrs: {
      "id": "My_Own_Self"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a419df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0